module.exports = __webpack_public_path__ + "media/images/logo/niet_gebruikt/ketenzorg-b67af1bcf9ad19570e495fe282cb17ea.svg";